var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "reports") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "reports"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.000000, 4.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33333333,0.00066667 L1.33333333,10.6666667 L12,10.6666667 L12,12 L0,12 L0,0.00066667 L1.33333333,0.00066667 Z M11.333334,2.000667 L11.333334,10 L8.666667,10 L8.666667,2.000667 L11.333334,2.000667 Z M8,6 L8,10 L5.333333,10 L5.333333,6 L8,6 Z M4.666667,4.666667 L4.666667,10 L2,10 L2,4.666667 L4.666667,4.666667 Z",
    id: "Combined-Shape",
    fill: "#ffffff",
    fillRule: "nonzero"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.588eb28bf190090fc81c4d5f139aeca0.svg";
export { ForwardRef as ReactComponent };